// extracted by mini-css-extract-plugin
export default {"icon":"smallIcon_icon__TGhPv"};